module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House04.6932faa9.jpg";